import { CheckCircle2 } from "lucide-react";

export function ConfirmationsBanner({ confirmations, onRefresh }) {
  if (!confirmations || confirmations.length === 0) return null;
  const total = confirmations.length;
  const confirmed = confirmations.filter((c) => c.confirmed_at).length;
  const pct = Math.round((confirmed / total) * 100);
  return (
    <div
      data-testid="confirmations-banner"
      className="rounded-md border border-zinc-800 bg-zinc-900/60 p-4 flex items-center gap-4 flex-wrap"
    >
      <div className="flex items-center gap-2">
        <CheckCircle2 className="w-4 h-4 text-emerald-400" />
        <div className="text-overline text-zinc-400">Receipt Confirmations</div>
      </div>
      <div className="flex-1 min-w-[200px]">
        <div className="h-1.5 rounded-full bg-zinc-800 overflow-hidden">
          <div
            className="h-full bg-emerald-500 transition-all"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>
      <div className="text-sm font-mono text-zinc-300">
        <span className="text-emerald-400 font-semibold">{confirmed}</span>
        <span className="text-zinc-600"> / </span>
        <span>{total}</span>
        <span className="text-zinc-500 ml-2 text-xs">({pct}%)</span>
      </div>
      <button
        data-testid="refresh-confirmations-btn"
        onClick={onRefresh}
        className="text-xs text-amber-500 hover:text-amber-400 uppercase tracking-widest"
      >
        Refresh
      </button>
    </div>
  );
}
